import { Typography } from '@mui/joy';

import { theme } from 'theme';
import { Color, Level } from 'theme/enums';

interface IProps {
  label: string;
  count: number;
}

// One text flow, so a wrapping label keeps its count right after the colon.
export const WarningCountLine = ({ label, count }: IProps) => (
  <Typography
    level={Level.BODY_XS}
    sx={{ color: `rgba(${theme.palette.neutral.mainChannel} / 1)`, fontWeight: 500 }}
  >
    {`${label}:`}
    <Typography component="span" level={Level.TITLE_SM} color={Color.DANGER} sx={{ ml: 0.5 }}>
      {count}
    </Typography>
  </Typography>
);
